/**
 * Generic log in form utilities. Enables the following behaviour:
 * - Email autocomplete
 * - Reveal password
 * - Displays a warning when CAPSLOCK is enabled.
 *
 * @author Matt Hallett
 */
'use strict';

const EmailGenie = require('Vendor/email-genie');

module.exports = FormUtils;

function FormUtils() {
	this.init = function() {
		this.ui = {
			emailField:     $('.js-email-field'),
			nameField:      $('.js-name-field'),
			passwordField:  $('.js-password-field'),
			passwordToggle: $('.js-password-toggle'),
		};

		// Disable caps lock warning on IE and Edge as we use our own
		document.msCapsLockWarningOff = true;
		
		this.bindEventHandlers();

		// Autocomplete email addresses with "gmail.com etc"
		this.ui.emailField.each((i,field) => {
			// EmailGenie default domains: ['gmail.com', 'outlook.com', 'hotmail.com', 'msn.com', 'live.com', 'googlemail.com', 'yahoo.com', 'me.com', 'icloud.com']
			// Add some custom ones as among our most popular
			var domains = ['btinternet.com', 'live.co.uk', 'hotmail.co.uk', 'yahoo.co.uk', 'aol.com', 'sky.com'];

			// Use data-domain="xxx" to pass in extra custom domain
			var domain = $(field).data('domain');
			if(domain) domains.push(domain);

			new EmailGenie(field, {	
				domains: domains
			});
		})
	};

	this.bindEventHandlers = function() {
		this.ui.passwordField.on('keydown keyup', this.capslock.bind(this));
		this.ui.passwordToggle.on('click', this.togglePassword.bind(this));
	};

	this.capslock = function(e) {
		var capsMsg = $(".js-caps-warning");

		if (e.originalEvent.getModifierState && 
			e.originalEvent.getModifierState("CapsLock")) {
			capsMsg.show();
		} else {
			capsMsg.hide();
		}
	}

	// Allow user to view their own password
	this.togglePassword = function(e) {
		var passwords = this.ui.passwordField;
		var password = $(e.currentTarget).siblings('.js-password-field') || passwords;
		
		if (passwords.attr('type') === "password") {
			passwords.attr('type', "text");
			this.ui.passwordToggle.html("Hide");
			password.focus();
		} else {
			passwords.attr('type', "password");
			this.ui.passwordToggle.html("Show");
		}
	}

	this.init();
}